import { render, staticRenderFns } from "./AddMT5Result.vue?vue&type=template&id=63f94c8a&"
import script from "./AddMT5Result.vue?vue&type=script&lang=js&"
export * from "./AddMT5Result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports